export default __webpack_public_path__ + "static/media/dr-sandra-dono-semi-round.ed2028c3.png";